import { render, staticRenderFns } from "./vantPointLoanRecord.vue?vue&type=template&id=5c3f6652&scoped=true"
import script from "./vantPointLoanRecord.vue?vue&type=script&lang=ts"
export * from "./vantPointLoanRecord.vue?vue&type=script&lang=ts"
import style0 from "./vantPointLoanRecord.vue?vue&type=style&index=0&id=5c3f6652&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3f6652",
  null
  
)

export default component.exports